import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;

export const IconContainer = styled.div`
  background: #e3f0ff;
  border-radius: 6px;
  padding: 7.5px;
  display: flex;
  align-items: center;
`;
